"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortKeys = exports.getFilters = void 0;
const casing_1 = require("@owner/casing");
const common_1 = require("./common");
const getFilters = ({ consumable, filters: customFilters = [], lists = [], sellable, }) => {
    const filters = [
        ...customFilters,
        {
            name: 'linkedToBrand',
            type: 'Boolean',
        },
        {
            name: 'linkedToPos',
            type: 'Boolean',
        },
        {
            name: 'brandLevel',
            type: 'Boolean',
        },
        {
            name: 'available',
            type: 'Boolean',
        },
        // Empty/existing list filters
        ...lists.map(({ name }) => ({
            name: `has${(0, casing_1.camelToPascal)(name)}`,
            type: 'Boolean',
        })),
    ];
    if (consumable) {
        filters.push({
            name: 'glutenFree',
            type: 'Boolean',
        }, {
            name: 'vegetarian',
            type: 'Boolean',
        }, {
            name: 'alcohol',
            type: 'Boolean',
        });
    }
    if (sellable)
        filters.push({ name: 'taxable', type: 'Boolean' });
    return filters;
};
exports.getFilters = getFilters;
const getSortKeys = ({ sortKeys: customSortKeys, sellable, }) => {
    const sortKeys = [
        ...customSortKeys,
        'name',
        'displayName',
        'createdAt',
        'updatedAt',
    ];
    if (sellable)
        sortKeys.push('amount', 'taxRate', 'metadata.totalRevenue', 'metadata.quantitySold');
    return (0, common_1.removeDuplicates)(sortKeys);
};
exports.getSortKeys = getSortKeys;
//# sourceMappingURL=filtering.js.map